module.exports = __webpack_public_path__ + "ta-waters.jpg";